import * as React from 'react'

import { observer } from 'mobx-react'

import Localization from '~/client/src/shared/localization/LocalizationManager'
import { TWO_MB } from '~/client/src/shared/utils/fileValidationHelper'

import ProjectImageField from './ProjectImageField'

// Accept larger than logo/avatar images for header
const MAX_HEADER_IMAGE_WIDTH = 4000
const MAX_HEADER_IMAGE_HEIGHT = 3000

interface IProps {
  projectHeaderImageUrl: string
  projectId: string
  isNewProjectSelected: boolean
  isProjectHeaderImageChanged: boolean
  onProjectHeaderImageChange: (headerImageUrl: string) => void
  onProjectHeaderImageSave: () => void
  renderDoneButton(
    clickHandler: () => void,
    isHidden?: boolean,
    isDisabled?: boolean,
  ): JSX.Element
}

const ProjectHeaderImageBlock: React.FC<IProps> = observer(
  ({
    projectHeaderImageUrl,
    projectId,
    isNewProjectSelected,
    isProjectHeaderImageChanged,
    onProjectHeaderImageChange,
    onProjectHeaderImageSave,
    renderDoneButton,
  }: IProps) => {
    return (
      <div className="tw:flex tw:items-start tw:gap-3 tw:px-[30px] tw:py-2">
        <div className="tw:w-[350px]">
          <ProjectImageField
            imageUrl={projectHeaderImageUrl}
            projectId={projectId}
            label={Localization.translator.projectHeaderImage}
            alt={Localization.translator.image}
            onChange={onProjectHeaderImageChange}
            maxFileSize={TWO_MB}
            maxWidth={MAX_HEADER_IMAGE_WIDTH}
            maxHeight={MAX_HEADER_IMAGE_HEIGHT}
            shoulOmitCreateLog
          />
        </div>
        {!isNewProjectSelected &&
          renderDoneButton(
            onProjectHeaderImageSave,
            !isProjectHeaderImageChanged,
          )}
      </div>
    )
  },
)

export default ProjectHeaderImageBlock
